import filter from 'lodash/filter';

import {
  getOfferByIdLocallyOrRemotely,
  fetchChannelCardStateLocally
} from '../../helper/LearningSpaceServices/DataService';

export async function fetchLearnerChannelOfferLocally(offerId, userId) {
  try {
    const offer = await getOfferByIdLocallyOrRemotely(offerId);
    if (!offer) throw new Error('OFFER_NOT_FOUND');
    const states = await fetchChannelCardStateLocally(offerId, userId);

    return {
      offer,
      states: filter(states),
      enrolments: [],
      stateInteractions: [],
      curriculumOffers: []
    };
  } catch (error) {
    console.log('Error in fetching offer data locally for channelId =', offerId, ':', error);
    return null;
  }
}
